<template>
  <div style="margin-top: 20px;">
    <!-- 模块成绩 -->
    <div style="padding:0 16px">
      <span >请输入用户名/姓名并选择查询的模块后点"查询"按钮进行查询</span>
    </div>
    
    <div class="title">
        <span class="title-stu">学生：</span>
        <van-cell-group style="width:76%;">
          <van-field v-model="valueName" placeholder="请输入用户名/姓名" />
        </van-cell-group>
    </div>
    <van-panel>
      <van-field
        readonly
        clickable
        label="模块"
        :value="valueMod"
        placeholder="请选择模块"
        @click="omModShow"
      />
      <van-popup v-model="modShow" position="bottom">
        <van-picker
          show-toolbar
          :columns="modColumns"
          :default-index="modIndex"
          @cancel="modShow = false"
          @confirm="onConfirmMod"
        />
      </van-popup>
    </van-panel>
    <van-button type="primary" size="large" @click="search" style="margin-top:15px;">查询</van-button>
    <ul class="scrollList">
      <li v-for="item of hoseList" v-bind:key="item.AchievementID">
        <div class="box-body">
          <div class="body-title">
            <h3 v-cloak style="font-weight:700">{{item.StudentName}}</h3>
            <h3 v-cloak style="margin-left:10px">{{item.UserName}}</h3>
          </div>
          <div class="body-content">
            <span class="sex-name" v-cloak>{{item.AchievementName}}</span>
            <span class="full-name" v-cloak style="margin-left:20px">{{item.StudentScore}}</span>
            <span class="full-name" v-cloak style="margin-left:20px">{{item.StudentCredit}}学分</span>
          </div>
          
        </div>
      </li>
    </ul>

    <!-- 数据全部加载完毕显示 -->
    <div style="text-align:center">
      <span v-if="hoseListLength">未查到该学生的模块成绩</span>
    </div>
  </div>
</template>
<script>
  export default {
    name: "adminShowAchievement",
    components: {},
    data() {
      return {
        valueName: "",
        // 学年
        mod: "",
        valueMod: "",
        modShow: false,
        modIndex: 0,
        modColumns: [],
        modList: [],
        dataActiveItem: 0,

        hoseListLength: false,
        hoseList: [] //table数据
      };
    },
    computed: {
      apipath() {
        return this.$store.state.apiPath;
      }
    },
    created() {
      this.getMod();
    },
    mounted() {},
    methods: {
      // 获取模块
      async getMod() {
        let _this = this;
        let res = await this.xyapi.get(
          `${this.apipath}/api/Achievement/GetInfoByDisciplineID`, {id:0}
        );
        if (res.success) {
          var arr = res.data;
          if (arr.length > 0) {
            for (var i = 0; i < arr.length; i++) {
              _this.modColumns.push({
                ID: arr[i].AchievementID,
                text: arr[i].AchievementName,
                stay: false
              });
            }
          } else {
            // _this.$toast.fail('暂无模块可选');
          }
        } else {
          _this.$toast.fail(res.msg);
        }
      },

      // 点击选择模块
      omModShow() {
        if (this.modColumns.length > 0) {
          this.modShow = true;
        } else {
          this.$toast.fail("暂无模块可选");
        }
      },

      // 确定模块
      onConfirmMod(value) {
        var _this = this;
        _this.modShow = false;
        // _this.onConfirm(value, _this.modList);
        this.valueMod = value.text;
        this.achievementID = value.ID;
      },
      // 选中
      // onConfirm(value, list) {
      //     var item = '';
      //     for(var i = 0; i < list.length; i++){
      //         if(value === list[i].AchievementName){
      //             item = list[i];
      //         }
      //     };
      //     this.dataActiveItem = item
      // },

      // 查询
      search() {
        this.hoseList = [];
        if (!this.valueMod) {
          this.$toast.fail("请选择模块！");
          return;
        }
        if (!this.valueName) {
          this.$toast.fail("请输入用户名/姓名！");
          return;
        }
        var _data = {
          achievementID: this.achievementID,
          seachText: this.valueName
        };

        this.getTP(_data);
      },

      async getTP(data) {
        let res = await this.xyapi.get(
          `${this.apipath}/api/Achievement/GetMobelAchievementScore/`,
          {
            seachText: this.valueName,
            achievementID: data.achievementID
          }
        )
        if (res.success) {
          this.hoseList = [];
          if (res.data !== null && res.data.length > 0) {
            this.hoseList = res.data;
            
            this.hoseListLength = false;
          } else {
            this.hoseListLength = true;
          }
        } else {
          this.$toast.fail(res.msg);
        }
      }
    }
  };
</script>
<style lang="less" scoped>
.title{
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title-stu{
    width: 19%;
    text-align: center;
  }
}
.box-body{
  padding: 20px;
  .body-title{
    margin-bottom: 20px
  }
}
</style>
